import { DocumentInfo } from './document'
import { Warnings } from './common'

const validInvoiceStatuses = ['PENDING', 'APPROVED_FOR_FUNDING', 'FUNDED', 'PAID', 'REJECTED']
export type InvoiceStatus = 'PENDING' | 'APPROVED_FOR_FUNDING' | 'FUNDED' | 'PAID' | 'REJECTED'

export function isInvoiceStatus(val: string): val is InvoiceStatus {
  return validInvoiceStatuses.includes(val)
}

export type InvoiceCollectionResponse = {
  invoices: InvoiceSummaryInfo[]
}

export type InvoiceSummaryInfo = {
  id: string
  invoiceNumber: string
  referenceNumber: string
  companyClientId: string
  companyClientName: string
  companyDebtorId: string
  companyDebtorName: string
  termId: string
  termName: string
  status: string
  invoiceAmount: number
  invoiceBalance: number
  invoiceDate: string
  notes: string
  documents: DocumentInfo[]
  noaFileSize?: number
  verificationStatus: string
  changelog: InvoiceChangelogInfo[]
  ineligible: boolean
  disputed: boolean
  createdOn: string
  purchaseFeeAmount: number
  escrowReserveAmount: number
  cashReserveAmount: number
  advanceAmount: number
  daysAged: number
  daysOutstanding: number
  paidDate: string
  paymentStatus: string
  fundedDate: string
  paymentTransactionNumber: string[]
  cashEscrowAmount?: number
  fuelAdvanceId: string
  fuelAdvanceReferenceNumber: string
  fuelAdvanceAmount: number
  forcedTermId: string
  forcedTermName: string
  companyBrokerId: string
  companyBrokerName: string
  invoiceType: string
  vendorPaymentAmount: number
  vendorInvoiceId: string
  vendorAdvanceAmount: number
  quickPayFeeAmount: number
  quickPayFeeId: string
  vendorPaymentDate: string
  vendorFundingDate: string
  companyVendorName: string
  companyVendorId: string
  overAdvanceType: string
  overAdvanceAmount: number
  snapshotTermPurchaseRate: number
  snapshotTermEscrowReserveRate: number
  nonFactoredInvoice: boolean | string
  verificationMethod: string
  closedDate: string
}

export type InvoiceChangelogInfo = {
  logType: InvoiceChangelogLogType
  status: string
  method: string
  notes: string
  createdOn: Date
  userId: string
  userEmail: string
  ineligibleStatus: Boolean
  disputedStatus: Boolean
}

type InvoiceChangelogLogType = 'UPDATE' | 'VERIFICATION' | 'COLLECTION'

export type verificationNotesInfo = {
  status: string
  notes: string
  createdOn: Date
  userId: string
  userEmail: string
}

export type GetInvoiceCollectionParams = {
  q?: string
  status?: string
  debtor?: string | null
  verificationStatus?: string | undefined | null
  sort?: string
}

export type InvoiceCreateRequest = {
  invoiceNumber: string
  referenceNumber: string
  companyClientId?: string | null
  companyBrokerId?: string | null
  companyDebtorId: string
  invoiceAmount: number
  invoiceDate: Date
  notes: string
  vendorInvoiceId?: string | null
  vendorPaymentAmount?: number | null
  vendorPaymentDate?: Date | null
  companyVendorId?: string | null
  preferredPaymentMethod?: string | null
  dueDate?: Date | null
}

export type InvoiceResponse = {
  invoice: InvoiceSummaryInfo
  warnings: Warnings[]
}

export type UpdateInvoiceRequest = {
  companyClientId?: string
  companyDebtorId?: string
  invoiceNumber?: number
  referenceNumber?: number
  invoiceAmount?: number
  invoiceDate?: string
  notes?: string
  documents?: string[]
}

export type SubmitInvoiceRequest = {
  invoiceNumber?: string
  referenceNumber?: string
  companyDebtorId?: string
  invoiceAmount?: number
  invoiceDate?: string
  notes?: string
  documents?: string[]
  preferredPaymentMethod?: string | null
}

export type InvoiceCsvResponse = {
  code: number
  status: string
  output: string[]
}

export type SectionInformationProps = {
  invoice?: InvoiceSummaryInfo
  title: string
}
